import ClientPreviewController from './client_preview_controller'

export default ClientPreviewController
